// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/:examCenterCode`
  | `/:examCenterCode/details`
  | `/:examCenterCode/details/courses`
  | `/:examCenterCode/details/members`
  | `/:examCenterCode/exam-events`
  | `/:examCenterCode/exam-events/:examEventId`
  | `/:examCenterCode/exam-events/:examEventId/examinees`
  | `/:examCenterCode/exam-events/:examEventId/results`
  | `/:examCenterCode/exam-events/:examEventId/score-report`
  | `/:examCenterCode/exam-events/activity-log`
  | `/:examCenterCode/exam-events/years`
  | `/:examCenterCode/exam-events/years/:year`
  | `/:examCenterCode/exam-events/years/:year/months/:month`
  | `/:examCenterCode/exam-events/years/:year/months/:month/create`
  | `/:examCenterCode/exam-events/years/:year/months/:month/recurring-create`
  | `/:examCenterCode/exam-events/years/:year/months/:month/recurring-create/review`
  | `/:examCenterCode/exam-location`
  | `/:examCenterCode/exam-location/cancellations`
  | `/:examCenterCode/exam-location/locations`
  | `/:examCenterCode/exam-location/locations/:roomId`
  | `/:examCenterCode/exam-location/locations/:roomId/computer-info`
  | `/:examCenterCode/exam-location/locations/:roomId/physical-info`
  | `/:examCenterCode/exam-location/requests`
  | `/:examCenterCode/exam-location/requests/:roomRequestId`
  | `/:examCenterCode/exam-location/requests/:roomRequestId/computer-info`
  | `/:examCenterCode/exam-location/requests/:roomRequestId/physical-info`
  | `/:examCenterCode/exam-location/requests/create`
  | `/:examCenterCode/exam-location/requests/draft/:requestId`
  | `/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId`
  | `/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId/computer-info`
  | `/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId/physical-info`
  | `/:examCenterCode/exam-proctors`
  | `/:examCenterCode/exam-proctors/proctors`
  | `/:examCenterCode/exam-proctors/proctors/:proctorId`
  | `/:examCenterCode/exam-proctors/requests`
  | `/:examCenterCode/exam-proctors/requests/:requestId`
  | `/:examCenterCode/exam-proctors/requests/create`
  | `/:examCenterCode/home`
  | `/:examCenterCode/proctoring`
  | `/:examCenterCode/proctoring/exam-events/:examEventId`
  | `/:examCenterCode/proctoring/exam-events/:examEventId/details`
  | `/:examCenterCode/proctoring/exam-events/:examEventId/details/session/:examSessionId`
  | `/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc`
  | `/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc/:examineeId`
  | `/:examCenterCode/proctoring/exam-events/:examEventId/registrations`
  | `/:examCenterCode/proctoring/exam-events/:examEventId/registrations/:examEventExamineeId`
  | `/access-denied`
  | `/admin/blocklist`
  | `/admin/blocklist/:blockedUserId`
  | `/admin/blocklist/:blockedUserId/:blockedRecordId`
  | `/admin/blocklist/create`
  | `/admin/exam-centers`
  | `/admin/exam-centers/:examCenterCode/details`
  | `/admin/exam-centers/:examCenterCode/details/exam-courses`
  | `/admin/exam-centers/:examCenterCode/details/members`
  | `/admin/exam-courses`
  | `/admin/exam-courses/:examCourseCode`
  | `/admin/exam-courses/:examCourseCode/details`
  | `/admin/exam-distribution`
  | `/admin/exam-distribution/available-qsets`
  | `/admin/exam-distribution/year`
  | `/admin/exam-distribution/year/:year`
  | `/admin/exam-distribution/year/:year/month`
  | `/admin/exam-distribution/year/:year/month/:month`
  | `/admin/exam-distribution/year/:year/month/:month/exam-assigning`
  | `/admin/exam-location`
  | `/admin/exam-location/activity-log`
  | `/admin/exam-location/cancellations`
  | `/admin/exam-location/locations`
  | `/admin/exam-location/locations/:roomId`
  | `/admin/exam-location/locations/:roomId/computer-info`
  | `/admin/exam-location/locations/:roomId/physical-info`
  | `/admin/exam-location/locations/:roomId/usage`
  | `/admin/exam-location/requests`
  | `/admin/exam-location/requests/:roomRequestId`
  | `/admin/exam-location/requests/:roomRequestId/computer-info`
  | `/admin/exam-location/requests/:roomRequestId/physical-info`
  | `/admin/exam-proctors`
  | `/admin/exam-proctors/activity-log`
  | `/admin/exam-proctors/proctors`
  | `/admin/exam-proctors/proctors/:examCenterProctorId`
  | `/admin/exam-proctors/requests`
  | `/admin/exam-proctors/requests/:requestId`
  | `/admin/exam-result-files`
  | `/admin/questionnaires`
  | `/admin/web-register-announcements`
  | `/ec-not-found`
  | `/user-not-active`

export type Params = {
  '/:examCenterCode': { examCenterCode: string }
  '/:examCenterCode/details': { examCenterCode: string }
  '/:examCenterCode/details/courses': { examCenterCode: string }
  '/:examCenterCode/details/members': { examCenterCode: string }
  '/:examCenterCode/exam-events': { examCenterCode: string }
  '/:examCenterCode/exam-events/:examEventId': { examCenterCode: string; examEventId: string }
  '/:examCenterCode/exam-events/:examEventId/examinees': { examCenterCode: string; examEventId: string }
  '/:examCenterCode/exam-events/:examEventId/results': { examCenterCode: string; examEventId: string }
  '/:examCenterCode/exam-events/:examEventId/score-report': { examCenterCode: string; examEventId: string }
  '/:examCenterCode/exam-events/activity-log': { examCenterCode: string }
  '/:examCenterCode/exam-events/years': { examCenterCode: string }
  '/:examCenterCode/exam-events/years/:year': { examCenterCode: string; year: string }
  '/:examCenterCode/exam-events/years/:year/months/:month': { examCenterCode: string; year: string; month: string }
  '/:examCenterCode/exam-events/years/:year/months/:month/create': { examCenterCode: string; year: string; month: string }
  '/:examCenterCode/exam-events/years/:year/months/:month/recurring-create': { examCenterCode: string; year: string; month: string }
  '/:examCenterCode/exam-events/years/:year/months/:month/recurring-create/review': { examCenterCode: string; year: string; month: string }
  '/:examCenterCode/exam-location': { examCenterCode: string }
  '/:examCenterCode/exam-location/cancellations': { examCenterCode: string }
  '/:examCenterCode/exam-location/locations': { examCenterCode: string }
  '/:examCenterCode/exam-location/locations/:roomId': { examCenterCode: string; roomId: string }
  '/:examCenterCode/exam-location/locations/:roomId/computer-info': { examCenterCode: string; roomId: string }
  '/:examCenterCode/exam-location/locations/:roomId/physical-info': { examCenterCode: string; roomId: string }
  '/:examCenterCode/exam-location/requests': { examCenterCode: string }
  '/:examCenterCode/exam-location/requests/:roomRequestId': { examCenterCode: string; roomRequestId: string }
  '/:examCenterCode/exam-location/requests/:roomRequestId/computer-info': { examCenterCode: string; roomRequestId: string }
  '/:examCenterCode/exam-location/requests/:roomRequestId/physical-info': { examCenterCode: string; roomRequestId: string }
  '/:examCenterCode/exam-location/requests/create': { examCenterCode: string }
  '/:examCenterCode/exam-location/requests/draft/:requestId': { examCenterCode: string; requestId: string }
  '/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId': { examCenterCode: string; requestId: string; roomRequestId: string }
  '/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId/computer-info': { examCenterCode: string; requestId: string; roomRequestId: string }
  '/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId/physical-info': { examCenterCode: string; requestId: string; roomRequestId: string }
  '/:examCenterCode/exam-proctors': { examCenterCode: string }
  '/:examCenterCode/exam-proctors/proctors': { examCenterCode: string }
  '/:examCenterCode/exam-proctors/proctors/:proctorId': { examCenterCode: string; proctorId: string }
  '/:examCenterCode/exam-proctors/requests': { examCenterCode: string }
  '/:examCenterCode/exam-proctors/requests/:requestId': { examCenterCode: string; requestId: string }
  '/:examCenterCode/exam-proctors/requests/create': { examCenterCode: string }
  '/:examCenterCode/home': { examCenterCode: string }
  '/:examCenterCode/proctoring': { examCenterCode: string }
  '/:examCenterCode/proctoring/exam-events/:examEventId': { examCenterCode: string; examEventId: string }
  '/:examCenterCode/proctoring/exam-events/:examEventId/details': { examCenterCode: string; examEventId: string }
  '/:examCenterCode/proctoring/exam-events/:examEventId/details/session/:examSessionId': { examCenterCode: string; examEventId: string; examSessionId: string }
  '/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc': { examCenterCode: string; examEventId: string }
  '/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc/:examineeId': { examCenterCode: string; examEventId: string; examineeId: string }
  '/:examCenterCode/proctoring/exam-events/:examEventId/registrations': { examCenterCode: string; examEventId: string }
  '/:examCenterCode/proctoring/exam-events/:examEventId/registrations/:examEventExamineeId': { examCenterCode: string; examEventId: string; examEventExamineeId: string }
  '/admin/blocklist/:blockedUserId': { blockedUserId: string }
  '/admin/blocklist/:blockedUserId/:blockedRecordId': { blockedUserId: string; blockedRecordId: string }
  '/admin/exam-centers/:examCenterCode/details': { examCenterCode: string }
  '/admin/exam-centers/:examCenterCode/details/exam-courses': { examCenterCode: string }
  '/admin/exam-centers/:examCenterCode/details/members': { examCenterCode: string }
  '/admin/exam-courses/:examCourseCode': { examCourseCode: string }
  '/admin/exam-courses/:examCourseCode/details': { examCourseCode: string }
  '/admin/exam-distribution/year/:year': { year: string }
  '/admin/exam-distribution/year/:year/month': { year: string }
  '/admin/exam-distribution/year/:year/month/:month': { year: string; month: string }
  '/admin/exam-distribution/year/:year/month/:month/exam-assigning': { year: string; month: string }
  '/admin/exam-location/locations/:roomId': { roomId: string }
  '/admin/exam-location/locations/:roomId/computer-info': { roomId: string }
  '/admin/exam-location/locations/:roomId/physical-info': { roomId: string }
  '/admin/exam-location/locations/:roomId/usage': { roomId: string }
  '/admin/exam-location/requests/:roomRequestId': { roomRequestId: string }
  '/admin/exam-location/requests/:roomRequestId/computer-info': { roomRequestId: string }
  '/admin/exam-location/requests/:roomRequestId/physical-info': { roomRequestId: string }
  '/admin/exam-proctors/proctors/:examCenterProctorId': { examCenterProctorId: string }
  '/admin/exam-proctors/requests/:requestId': { requestId: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
